import React from 'react'
import GoalServices from '../services/goal.services'
const goalService = new GoalServices();

export const STRATEGY_EVENTS = {
  OKR_VIEW : 'OKR_POPUP_STRATEGY_PILLAR_VIEW',
  OKR_CLICK : 'OKR_POPUP_STRATEGY_PILLAR_CLICK',
  KR_VIEW : 'KR_POPUP_STRATEGY_PILLAR_VIEW',
  KR_CLICK : 'KR_POPUP_STRATEGY_PILLAR_CLICK'
}
export const strategyEvent = (eventName, objectId, data) => {
    console.log("strategy-evettracking-data",  eventName, objectId, data);
    if(eventName !== undefined && data !== undefined) {
      const params = {
        'ref' : eventName,
        'objectId' : objectId,
        'data' : data
      }
      goalService.strategyEventTracking(params);
    }
}

export const strategyPillar = (strategyId, pillarId) => {
 return {
  'StrategyId' : strategyId,
  'PillarId' : pillarId
 }
}

export const openPillar = (strategyURL, strategyId, pillarId, eventName, objectId) => {
  const url = `${strategyURL}strategy/${strategyId}/pillars/${pillarId}`;
  window.open(url);
  if (eventName !== undefined && objectId !== undefined) {
    strategyEvent(eventName, objectId, strategyPillar(strategyId, pillarId));
  }
}